<template>
  <div>
    <v-stage ref="stage" :config="stageSize" @mousedown="handleStageMouseDown">
      <v-layer ref="layer">
        <v-image
          v-for="item in images"
          :key="item.id"
          :config="{
            image: item.image,
            name: item.name,
            x: item.x,
            y: item.y,
            width: item.width,
            height: item.height,
            draggable: item.draggable
          }"
        />
        <!-- <v-text v-for="item in images" :key="item.name" :config="{text: item.name, x: item.x + 10, y: item.y + item.height/2, fill: 'black', draggable: true}" /> -->
        <v-transformer ref="transformer" />
      </v-layer>
    </v-stage>
    <!-- <button @click="showStage()">Show Stage</button> -->
  </div>
</template>

<script>
const width = window.innerWidth;
const height = window.innerHeight;

export default {
  data() {
    return {
      stageSize: {
        width: width,
        height: height
      },
      selectedShapeName: ""
      // image: null
    };
  },
  mounted() {
    var test = this.images;
    console.log(test);
  },
  computed: {
    images() {
      var _images = [
        {
          x: 10,
          y: 10,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img1",
          src: require("../assets/salveShapes/1.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 10,
          y: 110,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img2",
          src: require("../assets/salveShapes/2.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 10,
          y: 210,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img3",
          src: require("../assets/salveShapes/3.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 10,
          y: 310,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img4",
          src: require("../assets/salveShapes/4.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 10,
          y: 410,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img5",
          src: require("../assets/salveShapes/5.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 310,
          y: 10,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img6",
          src: require("../assets/salveShapes/6.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 310,
          y: 110,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img7",
          src: require("../assets/salveShapes/7.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 310,
          y: 210,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img8",
          src: require("../assets/salveShapes/8.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 310,
          y: 310,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img9",
          src: require("../assets/salveShapes/9.jpg"),
          image: null,
          draggable: true
        },
        {
          x: 310,
          y: 410,
          width: 250,
          height: 100,
          // fill: "red",
          name: "img10",
          src: require("../assets/salveShapes/10.jpg"),
          image: null,
          draggable: true
        }
      ];

      _images.forEach(img => {
        var imageObj = new Image();

        imageObj.onload = () => {
          var image = new Konva.Image({
            image: imageObj
          });
        };
        imageObj.src = img.src;
        img.image = imageObj;
      });

      console.log(_images);
      return _images;
      // return groups;
    }
  },
  methods: {
    showStage() {
      console.log(this.$refs.stage);
      // this.$refs.stage.getStage().draw();
    },
    drawTimeZones() {
      var layer = new Konva.Layer();
      var dayWidth = this.width / 14;
      for (let day = 0; day < 14; day++) {
        let line = new Konva.Line({
          points: [day, 0, day, this.height],
          stroke: "black",
          strokeWidth: 5,
          lineCap: "round",
          lineJoin: "round"
        });

        layer.add(line);
        this.$refs.stage.getStage().add(layer);
      }
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      // console.log("I am click")
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = "";
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      console.log(name);
      const rect = this.images.find(r => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = "";
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getStage();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne("." + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.attachTo(selectedNode);
      } else {
        // remove transformer
        transformerNode.detach();
      }
      transformerNode.getLayer().batchDraw();
    }
  },
  created() {}
};
</script>
